import "~/scss/page-templates/home.scss";
// import "~/scss/components/moviesList.scss";

import EmblaCarousel from "embla-carousel";

import { Parallax } from "~/js/components/parallax/parallax";

console.log('home.ts');


const moviesListEl:HTMLElement|null = document.querySelector(".movies-list");
const emblaNode:HTMLElement|null = document.querySelector(".embla");

let emblaPrevButton:HTMLElement|null = null;
let emblaNextButton:HTMLElement|null = null;
let emblaContainer:HTMLElement|null = null;


if( moviesListEl !== null && emblaNode !== null ) {
  const emblaViewport:HTMLElement|null = emblaNode.querySelector(".embla__viewport");

  if( emblaViewport !== null ) {
    emblaContainer = moviesListEl.querySelector(".embla__container");
    emblaPrevButton = moviesListEl.querySelector(".embla__prev");
    emblaNextButton = moviesListEl.querySelector(".embla__next");

    const options = { 
      loop: true, 
      active: true, 
      // breakpoints: {
      //   '(min-width: 768px)' : { active: false }
      // }
    };
    const emblaApi = EmblaCarousel(emblaViewport, options);

    console.log(emblaApi);

    if( emblaPrevButton ) {
      emblaPrevButton.addEventListener("click", emblaApi.scrollPrev, false);

      console.log("initialize prev button");
    }

    if( emblaNextButton ) {
      emblaNextButton.addEventListener("click", emblaApi.scrollNext, false);
    }

    toggleCarouselButtons();
  }
  
}

function toggleCarouselButtons() {
  if( moviesListEl ) {
    let emblaSlides = moviesListEl.querySelectorAll(".embla__slide");
      
    let visibleSlidesCount = 3;

    if( window.innerWidth >= 768 ) {
      visibleSlidesCount = 4;

      // emblaContainer?.classList.add("no-scrolling");
      
    } else {
      emblaContainer?.classList.remove("no-scrolling");
    }

    console.log("emblaSlides.length:", emblaSlides.length);

    if( emblaSlides.length > visibleSlidesCount ) {
      if( emblaPrevButton ) {
        emblaPrevButton.classList.remove("hidden");
      }

      if( emblaNextButton ) {
        emblaNextButton.classList.remove("hidden");
      }
    } else {
      if( emblaPrevButton ) {
        emblaPrevButton.classList.add("hidden");
      }

      if( emblaNextButton ) {
        emblaNextButton.classList.add("hidden");
      }
    }
  }
}

window.addEventListener("resize", () => {
  toggleCarouselButtons();
})


let parallaxEls = document.querySelectorAll(".movie-slide__parallax-container");
let parallax = [];
for( let i=0; i<parallaxEls.length; i++ ) {
  let parallax = new Parallax(parallaxEls[i]);
}
